import React from 'react'
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom'

import Home from './home'
import Trip from './trip'
import Setting from './setting'
import Page404 from '../404'
import useBaseFontSize from '@/hooks/useBaseFontSize'

const Router = () => {
  const { path } = useRouteMatch()
  useBaseFontSize()

  return (
    <>
      <Switch>
        <Route path={`${path}`} exact render={() => <Redirect to={`${path}/home`}></Redirect>}>
        </Route>
        <Route exact path={`${path}/home`}>
          <Home></Home>
        </Route>
        <Route exact path={`${path}/trip`}>
          <Trip></Trip>
        </Route>
        <Route exact path={`${path}/setting`}>
          <Setting></Setting>
        </Route>
        <Route>
          <Page404 />
        </Route>
      </Switch>
    </>
  )
}

export default Router